export type MedicineIntent = 'continue' | 'regular';

export const MEDICINE_INTENT_OPTIONS: ReadonlyArray<{
  value: MedicineIntent;
  shortLabel: string;
  label: string;
  title: string;
}> = [
  {
    value: 'continue',
    shortLabel: 'C',
    label: 'Continue',
    title: 'Continue current medication',
  },
  {
    value: 'regular',
    shortLabel: 'R',
    label: 'Regular',
    title: 'Regular medicine',
  },
];

export function isMedicineIntent(value: unknown): value is MedicineIntent {
  return value === 'continue' || value === 'regular';
}

export function medicineIntentShortLabel(value: MedicineIntent | null | undefined): string {
  if (!value) {
    return '';
  }
  return MEDICINE_INTENT_OPTIONS.find((option) => option.value === value)?.shortLabel ?? '';
}

export function medicineIntentTitle(value: MedicineIntent | null | undefined): string {
  if (!value) {
    return '';
  }
  return MEDICINE_INTENT_OPTIONS.find((option) => option.value === value)?.title ?? '';
}

export function receptionNoteTooltip(
  note: string | null | undefined,
  intent: MedicineIntent | null | undefined,
): string {
  const trimmed = String(note || '').trim();
  if (!trimmed) {
    return '';
  }
  const intentLabel = medicineIntentTitle(intent);
  return intentLabel ? `${intentLabel} · ${trimmed}` : trimmed;
}
